/*
 * @Description:
 * @Autor: ZY
 * @Date: 2020-12-07 10:30:20
 * @LastEditors: ZY
 * @LastEditTime: 2021-01-27 19:20:07
 */
import { createApp, Directive } from 'vue'
import App from './App.vue'
// import './pwa/registerServiceWorker'
import '@/assets/iconfont/iconfont.css'
import * as directives from '@/directives'
import '@/permission'
import '@/styles/index.scss'
import 'normalize.css'
import { loadAllPlugins } from './plugins'
import router from './router'
import { store } from './store'
const app = createApp(App)
// 加载所有插件
loadAllPlugins(app)

// 自定义指令
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string]: Directive })[key])
})

app.use(store).use(router).mount('#app')
